<template>
    <div class="form-group" v-if="this.showMasse == true || hasmodulebureau == true ">
        <label>Masse (%) de la structure: </label>
        <input 	 type="number"
        		ref="comission" 
        		placeholder="Exemple 10"
        		min="0" class="form-control" 
        		name="office_masse" 
				v-model='percent'
				@change="updateComission()"
		/>
    </div>
</template>

<script>
export default {
  name: 'billingComissionComponent',
  props: ['old','hasmodulebureau'],
  data () {
    return {
    	percent : '',
        showMasse : false
    }
  },
  mounted(){
  	this.percent = this.old
  	this.$parent.$emit('update:comission', {
		'quantity': this.percent
	}),
    this.$parent.$on('update:encadrant', (e) => {
        this.showMasse = e.encadrant== "salarie" ? false : true
    })
  },
  methods : {
  	updateComission(){
  		this.$parent.$emit('update:comission', {
  			'quantity': this.percent
  		})
  	}
  }
}
</script>

<style lang="css" scoped>
</style>	
